import React from 'react';
import useNetworkQuality from 'hooks/useNetworkQuality';
import { SIGNALS } from 'utils/networkQuality';
import './style.scss';

const SIGNAL_CONFIG = {
  [SIGNALS.GOOD]: { color: '#4CAF50', label: 'Good', bars: 3 },
  [SIGNALS.WEAK]: { color: '#FF9800', label: 'Weak', bars: 2 },
  [SIGNALS.BAD]:  { color: '#F44336', label: 'Bad',  bars: 1 },
};

const NetworkIndicator = () => {
  const signal = useNetworkQuality();
  const config = SIGNAL_CONFIG[signal];

  if (!config) return null;

  return (
    <div className="network-indicator">
      <div className="network-indicator__bars">
        {[1, 2, 3].map((bar) => (
          <span
            key={bar}
            className={`network-indicator__bar network-indicator__bar--${bar}`}
            style={{
              backgroundColor: bar <= config.bars ? config.color : 'rgba(255,255,255,0.2)',
            }}
          />
        ))}
      </div>
      <span className="network-indicator__label" style={{ color: config.color }}>
        {config.label}
      </span>
    </div>
  );
};

export default NetworkIndicator;
